// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.api-ref-shell[data-v-61c1fa4c]{max-width:1400px;margin:0 auto}.scalar-frame[data-v-61c1fa4c]{width:100%;height:calc(100vh - 160px);border:1px solid #e0e0e0;border-radius:8px}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
